import request from '../request'

const LoginApi = {}

// 获取验证码
LoginApi.getVerCode = () => {
  return request({
    url: '/captchaImage',
    method: 'GET'
  })
}

// 登录
LoginApi.hanldeLogin = param => {
  return request({
    url: '/login',
    method: 'POST',
    data: param
  })
}

// 安全退出登录
LoginApi.hanldeLoginOut = params => {
  return request({
    url: '/logout',
    method: 'POST',
    data: params
  })
}

export default LoginApi
